<template>
  <div class="addLive">
    <div class="addLive-content">
      <div class="addLive-main">
        <div class="main-label">image</div>
        <div class="main-input">
          <el-input v-model="obj.image" placeholder="请输入image地址"></el-input>
        </div>
        <div class="main-boolean">必填</div>
        <div class="main-desc">直播封面图</div>
      </div>
      <div class="addLive-main">
        <div class="main-label">isOpen</div>
        <div class="main-input">
          <el-radio-group v-model="obj.isOpen">
            <el-radio :label="true">公开</el-radio>
            <el-radio :label="false">不公开</el-radio>
          </el-radio-group>
        </div>
        <div class="main-boolean">非必填</div>
        <div class="main-desc">在你的企业门户页面,默认开启显示本场直播,不开启不显示</div>
      </div>
      <div class="addLive-main">
        <div class="main-label">play_mode</div>
        <div class="main-input">
          <el-radio-group v-model="obj.play_mode">
            <el-radio :label="2">横屏</el-radio>
            <el-radio :label="1">竖屏</el-radio>
          </el-radio-group>
        </div>
        <div class="main-boolean">非必填</div>
        <div class="main-desc">
          直播类型1:竖屏, 2:横屏。如果使用指定的APP直播助手进行直播，则只能选择竖屏直播
        </div>
      </div>
      <div class="addLive-main">
        <div class="main-label">start_time</div>
        <div class="main-input">
          <el-date-picker style="width:300px;" v-model="obj.start_time" type="datetime" placeholder="选择日期时间" >
          </el-date-picker>
        </div>
        <div class="main-boolean">必填</div>
        <div class="main-desc">直播开始时间</div>
      </div>

      <div class="addLive-main">
        <div class="main-label">stream_url_type</div>
        <div class="main-input">
          <el-radio-group v-model="obj.stream_url_type">
            <el-radio :label="1">推流直播</el-radio>
            <el-radio :label="2" :disabled="obj.play_mode == 1">单人网页直播</el-radio>
            <el-radio :label="3" :disabled="obj.play_mode == 1" style="margin-top: 5px">连麦直播</el-radio>
            <el-radio :label="4" style="margin-top: 5px">定时推流视频</el-radio>
            <el-radio :label="5" style="margin-top: 5px">拉流视频</el-radio>
            <el-radio :label="6" :disabled="obj.play_mode == 2" style="margin-top: 5px">手机直播</el-radio>
          </el-radio-group>
        </div>
        <div class="main-boolean">必填</div>
        <div class="main-desc">
          直播平台方式1=推流直播, 2=单人网页直播，3=连麦直播
          4=定时推流视频,5=拉流视频,6=手机直播。如果使用指定的APP直播助手进行直播，则必须取值为
          2（即单人网页直播，因为用的都是rtc协议）
        </div>
      </div>
      <div class="addLive-main">
        <div class="main-label">third_image</div>
        <div class="main-input">
          <el-input v-model="obj.third_image" placeholder="请输入third_image"></el-input>
        </div>
        <div class="main-boolean">非必填</div>
        <div class="main-desc">微信分享缩略图</div>
      </div>
      <div class="addLive-main">
        <div class="main-label">title</div>
        <div class="main-input">
          <el-input v-model="obj.title" placeholder="请输入title"></el-input>
        </div>
        <div class="main-boolean">必填</div>
        <div class="main-desc">直播名称</div>
      </div>
      <div class="addLive-main">
        <div class="main-label">teacher_id</div>
        <div class="main-input">
          <el-input v-model="obj.teacher_id" placeholder="请输入teacher_id"></el-input>
        </div>
        <div class="main-boolean">非必填</div>
        <div class="main-desc">
          讲师用户id(直播平台)，如果需要对接讲师，请参考文档下面的讲师账号相关接口
          <a href="https://www.youinsh.com/doc/apass-api.html#%E5%88%9B%E5%BB%BA%E8%AE%B2%E5%B8%88%E4%B8%BB%E6%92%AD%EF%BC%89%E8%B4%A6%E5%8F%B7" target="_blank">
            https://www.youinsh.com/doc/apass-api.html#%E5%88%9B%E5%BB%BA%E8%AE%B2%E5%B8%88%E4%B8%BB%E6%92%AD%EF%BC%89%E8%B4%A6%E5%8F%B7
          </a>
        </div>
      </div>
      <div class="addLive-main">
        <div class="main-label">enterprise_id</div>
        <div class="main-input">
          <el-input v-model="obj.enterprise_id" placeholder="请输入enterprise_id"></el-input>
        </div>
        <div class="main-boolean">非必填</div>
        <div class="main-desc">主或子账号id，不传默认为主账号id</div>
      </div>
    </div>
    <div class="dialog-footer">
      <el-button @click="cancelhandle">取 消</el-button>
      <el-button type="primary" @click=saveHandle>确 定</el-button>
    </div>
  </div>
</template>
<script>


export default {
  props:{
    baseUrl:{
      type:String,
      default:''
    },
  },
  data() {
    return {
      obj: {
        isOpen: true,           // 在你的企业门户页面,默认开启显示本场直播,不开启不显示
        title:'',               // 直播名称
        image: "",              // 直播封面图
        start_time: "",         // 直播开始时间
        play_mode:2,            // 直播类型默认横屏
        stream_url_type: 0,     // 直播平台方式
        third_image:'',         // 微信分享缩略图
        teacher_id:'',          // 讲师用户id(直播平台)
        enterprise_id:''        // 主或子账号id，不传默认为主账号id
      }
    };
  },
  methods:{
    cancelhandle(){
      this.$emit('closeDiag')
    },
    saveHandle(){

      if(!this.obj.title){
        this.$message({
          message: '请输入直播名称',
          type: 'warning'
        });
        return
      }
      if(!this.obj.stream_url_type){
        this.$message({
          message: '请输入直播平台方式',
          type: 'warning'
        });
        return
      }
      if(!this.obj.start_time){
        this.$message({
          message: '请输入直播开始时间',
          type: 'warning'
        });
        return
      }
      if(!this.obj.image){
        this.$message({
          message: '请输入直播封面图',
          type: 'warning'
        });
        return
      }

      this.$axios.post(`${this.baseUrl}/v1/course/system/create_course/`, this.obj).then(res => {
        if (res.status == 200 && res.data.code == 200) {
          this.$message({
            showClose: true,
            message: '创建直播成功',
            type: 'success'
          });
          this.$emit('closeDiag')
        }else{
          this.$message.error(res.data.msg)
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-input {
  width: 300px !important;
}
.addLive {
  .addLive-content {
    height: 400px;
    overflow: auto;
    .addLive-main {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 20px;
      .main-label {
        width: 120px;
      }
      .main-input {
        width: 300px;
      }
      .main-boolean {
        padding-left: 10px;
        width: 50px;
      }
      .main-desc {
        flex: 1;
        padding-left: 10px;
      }
    }
  }
  .dialog-footer {
    margin-top: 20px;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/liveList/liveSet/addLive.vue